module.exports = __webpack_public_path__ + "img/rotate.0a99a642.svg";